import { render } from "./MyTable.vue?vue&type=template&id=4a79747f"
import script from "./MyTable.vue?vue&type=script&lang=js"
export * from "./MyTable.vue?vue&type=script&lang=js"

import "./MyTable.vue?vue&type=style&index=0&id=4a79747f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__